<template lang="html">
  <div class="component-wrapper">
    <v-main >
      <ParallaxIceverg />
      <h1 class="text-center">Aviso legal</h1>
      <section class="container flex">
        <h2>1.  INFORMACIÓN DEL TITULAR</h2>
        <p>
          Iceverg Ventures SL es el titular del dominio iceverg.com con NIF: B67538512, con domicilio en Calle Bellaterra 6, Cornellà del Llobregat y correo electrónico de contacto info[at]iceverg.com (en adelante, <b>ICEVERG</b>).
          Cualquier uso de esta web implica la aceptación de todas las condiciones incluidas en estos y otros documentos legales y su sumisión a la legislación española en todo momento, renunciando expresamente a cualquier otro fuero.
        </p>

        <h2>2.	GARANTÍAS Y RESPONSABILIDADES</h2>
        <p>
          <b>ICEVERG</b> a través de su página web ofrece información sobre sus servicios a título meramente enunciativo.
          El usuario que accede al web reconoce y acepta voluntaria y expresamente la responsabilidad del uso de esta página web y se compromete a no realizar ningún acto que pueda infringir la ley o las condiciones establecidas en estos términos legales, en cuyo caso podrá comportar las correspondientes responsabilidades legalmente establecidas.
          <b>ICEVERG</b> se reserva el derecho a efectuar, en cualquier momento y sin necesidad de previo aviso, modificaciones y actualizaciones de la información contenida en la web, de su configuración y presentación y de las condiciones generales, así como de eliminar información o suspender temporalmente la accesibilidad al web.
          Así mismo, o puede garantizar:
          <ul>
            <li>La inexistencia de interrupciones o errores en el acceso a la web o a su contenido, ni se hace responsable de posibles problemas técnicos que se produzcan durante la conexión a Internet.
              Y no se hace responsable de los daños que se pudieran derivar de interferencias, omisiones o virus informáticos motivados por causas ajenas al titular de la web, así como de daños causados por terceras personas mediante intromisiones ilegítimas o daños al sistema informático fuera del control del titular de la web.
            </li>
            <li>La aplicación de su Política de Privacidad a accesos mediante enlaces de terceros a esta web, ni a través de enlaces de esta web a otras webs.
              <ul>
                <li>Todo enlace de terceros a esta web deberá hacerse a su página principal o de entrada, previa autorización y por escrito del titular y no se podrá realizar ninguna modificación, limitación ni ningún tipo de manifestación sobre la web, debiendo cumplir, asimismo, con el resto de previsiones de esta normativa.</li>
                <li>En caso de existir enlaces no supervisados por <b>ICEVERG</b> no se asumirán responsabilidades sobre los enlaces o contenidos o consecuencias del uso de dichos enlaces.  </li>
              </ul>
            </li>
          </ul>
        </p>
        <h2>3.	PROPIEDAD INTELECTUAL</h2>
        <p>
          Esta web se rige por las leyes españolas y por la legislación nacional e internacional sobre propiedad intelectual e industrial.
          Todos los contenidos incluidos en la web (textos, contenidos audiovisuales, código fuente, diseño gráfico, signos, logos, marcas, bases de datos, programas informáticos, edición, programación, compilación y otros elementos y contenidos necesarios para su funcionamiento) son propiedad del titular de esta.
          Cualquier uso no autorizado de estos contenidos será considerado un incumplimiento de los derechos de propiedad intelectual o industrial y podrá dar lugar a consecuencias legales.
          Los contenidos que pudiera contener la web que no fueran de su titularidad gozan de la autorización de sus titulares para su uso y comunicación y están protegidas por los correspondientes derechos de propiedad intelectual.
          La simple navegación o uso de la web no otorga en ningún caso licencia o cesión total o parcial de derechos sobre los derechos de propiedad intelectual quedando expresamente prohibida cualquier transmisión, reproducción, distribución, comunicación pública o transformación total o parcial de los mismos sin previo consentimiento de sus titulares.
        </p>
        <h2>4.	PRIVACIDAD</h2>
        <p><b>ICEVERG</b> garantiza la confidencialidad de los datos personales que usted facilite a nuestra plataforma y la aplicación de las medidas de seguridad establecidas por la normativa. Si quiere conocer nuestra Política de Privacidad <a href="/privacy">clique aquí.</a></p>
      </section>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import ParallaxIceverg from '@/components/sections/ParallaxIceverg';
import Footer from '@/components/Footer';
  export default {
    name: "Legal",
    components: {
      ParallaxIceverg,
      Footer
    }
  }
</script>

<style lang="css">
h1{
  padding-top: 50px;
}
p{
  padding-top: 15px
}
h2{
  margin-top:45px;
}
</style>
